import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { Section, type DcrNavigationState } from './dcrNavigation.types';

export const filteredArr = (array: Section[]) =>
	array.reduce((acc, current) => {
		const x = acc.find(item => item.id === current.id);
		if (!x) {
			return acc.concat([current]);
		}
		return acc;
	}, [] as Section[]);

export const useDcrNavigationStore = create<DcrNavigationState>()(
	devtools(set => ({
		sections: [],

		addSection: (section: Section) =>
			set(({ sections }) => ({
				sections: filteredArr([...sections, section])
			})),
		setHidden: (id: Section['id'], hidden: boolean) =>
			set(({ sections }) => ({
				sections: sections.map(s => (s.id === id ? { ...s, hidden } : s))
			})),
		removeSection: (id: Section['id']) =>
			set(({ sections }) => ({
				sections: sections.filter(s => s.id !== id)
			}))
	}))
);
